import React from 'react';
import { GiftIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="overflow-hidden rounded-2xl shadow-lg shadow-black/20" data-id="element-18" data-mp="2o64ze3786luz">
      <div className="flex items-center gap-3 bg-brand-light px-4 py-3 md:px-5" data-id="element-19" data-mp="2t3mzd439lqqu">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-navy px-2.5 py-1 font-display text-[10px] font-black uppercase tracking-wider text-white md:text-[11px]" data-id="element-20" data-mp="2x3p09b16eg52">
          <GiftIcon className="h-3.5 w-3.5 text-brand-light" aria-hidden="true" data-id="element-21" data-mp="25cr9icidd5m8" />
          Bonus {bonus.number}
        </span>
        <h3 className="font-display text-sm font-black uppercase leading-tight text-navy md:text-base" data-id="element-22" data-mp="29dl2vlekzcmi">{bonus.name}</h3>
      </div>
      <div className="bg-white px-4 py-4 md:px-5" data-id="element-23" data-mp="2e7p5jsgtcyhs">
        <p className="text-sm font-semibold leading-relaxed text-navy" data-id="element-24" data-mp="1hn6s3y1v6gf2">{bonus.summary}</p>
        <p className="mt-2 text-sm leading-relaxed text-steel" data-id="element-25" data-mp="1loi9xhehxxcp">{bonus.includes}</p>
        <p className="mt-2 text-sm italic leading-relaxed text-brand" data-id="element-26" data-mp="1x2mqj6t01q6x">{bonus.idealFor}</p>
        <div className="mt-4 flex items-center justify-end gap-3 border-t border-navy/10 pt-3" data-id="element-27" data-mp="1s3a7kx59139m">
          <span className="text-sm font-black text-steel line-through decoration-red-600 decoration-2" data-id="element-28" data-mp="1nc1xs000bfvx">
            ${bonus.value} USD
          </span>
          <span className="rounded-md bg-navy px-3 py-1 font-display text-xs font-black uppercase text-brand-light" data-id="element-29" data-mp="1icp71460loo2">
            Free
          </span>
        </div>
      </div>
    </article>;
}